import {
    getIsSendApiPending,
    getIsValidateApiPending,
    getOtpValue,
} from '../../../selectors/ugMotorInsurance/personalDetails';
import {
    apiTransitionSendOtp,
    apiTransitionValidateOtp,
    setOtpValue,
    setOtpValid,
    setShowOtpModal,
    setEmailIsValidated,
} from '../../../actions/ugMotorInsurance/personalDetails';
import { getCustomerIdValue } from '../../../selectors/ugMotorInsurance/quote';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { setExpiredAuth } from '../../../actions/ugMotorInsurance/quote';

function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const sendEmailOtpService = (store, next, action) => {
    (async () => {
        if (!getIsSendApiPending(store.getState())) {
            store.dispatch(apiTransitionSendOtp.pending());

            try {
                await send(store.getState());
                store.dispatch(setOtpValue(null));
                store.dispatch(setOtpValid(null));

                //cater for nodemailer delay
                await wait(10000);

                store.dispatch(apiTransitionSendOtp.success());

                store.dispatch(setShowOtpModal(true));
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }

                store.dispatch(apiTransitionSendOtp.failure());
            }
        }
    })();
    return next(action);
};

const otpPayload = (state) => {
    const customerId = getCustomerIdValue(state);

    const payload = {
        id: customerId.value,
    };

    return {
        ...payload,
    };
};

const send = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/ke-motor-insurance/send-otp';
        return await axios.post(url, otpPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export const validateOtpService = (store, next, action) => {
    (async () => {
        if (!getIsValidateApiPending(store.getState())) {
            store.dispatch(apiTransitionValidateOtp.pending());
            try {
                await validate(store.getState());
                store.dispatch(apiTransitionValidateOtp.success());
                store.dispatch(setEmailIsValidated(true));
                store.dispatch(setOtpValid(null));
                store.dispatch(setShowOtpModal(false));
            } catch (e) {
                console.error(e.response);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionValidateOtp.failure());
                store.dispatch(setEmailIsValidated(false));
                store.dispatch(setOtpValid('OTP not valid'));
            }
        }
    })();
    return next(action);
};

const validatePayload = (state) => {
    const customerId = getCustomerIdValue(state);
    const otp = getOtpValue(state);

    const payload = {
        id: customerId.value.toString(),
        otp: otp.value.toString(),
    };

    return {
        ...payload,
    };
};

const validate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/validate-otp';
        return await axios.post(url, validatePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
